import { 
  Wifi, 
  Wind, 
  Car, 
  CookingPot, 
  Bath,
  ArrowUpDown, 
  Camera, 
  Printer,
  Users, 
  Package,
  HeadphonesIcon,
  UserSquare2,
  Truck,
  Camera as PhotoCamera,
  Scissors,
  Stethoscope,
  Dumbbell,
  Presentation,
  Square,
  ChefHat,
  Clock,
  PawPrint,
  Brush,
  Coffee,
  Droplets,
  Lock,
  Lightbulb,
  ReceiptIcon,
  Sun,
  Building2,
  LucideIcon
} from 'lucide-react';

export type AmenityKey = 
  | 'wifi'
  | 'air-conditioning'
  | 'parking'
  | 'kitchen'
  | 'bathroom'
  | 'elevator'
  | 'security-cameras'
  | 'printer'
  | 'meeting-room'
  | 'storage'
  | 'reception'
  | 'natural-light'
  | 'sound-system'
  | 'changing-room'
  | 'loading-dock'
  | 'photography-equipment'
  | 'beauty-equipment'
  | 'medical-equipment'
  | 'yoga-mats'
  | 'projector'
  | 'whiteboard'
  | 'catering-service'
  | '24-7-access'
  | 'pet-friendly'
  | 'cleaning-service'
  | 'coffee-machine'
  | 'water-dispenser'
  | 'lockers'
  | 'exhibition-lighting';

export const amenityIcons: Record<AmenityKey, LucideIcon> = {
  'wifi': Wifi,
  'air-conditioning': Wind,
  'parking': Car,
  'kitchen': CookingPot,
  'bathroom': Bath,
  'elevator': ArrowUpDown,
  'security-cameras': Camera,
  'printer': Printer,
  'meeting-room': Users,
  'storage': Package,
  'reception': ReceiptIcon,
  'natural-light': Sun,
  'sound-system': HeadphonesIcon,
  'changing-room': UserSquare2,
  'loading-dock': Truck,
  'photography-equipment': PhotoCamera,
  'beauty-equipment': Scissors,
  'medical-equipment': Stethoscope,
  'yoga-mats': Dumbbell,
  'projector': Presentation,
  'whiteboard': Square,
  'catering-service': ChefHat,
  '24-7-access': Clock,
  'pet-friendly': PawPrint,
  'cleaning-service': Brush,
  'coffee-machine': Coffee,
  'water-dispenser': Droplets,
  'lockers': Lock,
  'exhibition-lighting': Lightbulb,
};

export interface AmenityDisplayInfo {
  icon: LucideIcon;
  label: string;
}

export const getAmenityIcon = (amenity: string): LucideIcon => {
  return amenityIcons[amenity as AmenityKey] || Building2;
};
